export const getProductListQuery = `
  query GetProductList($input: ListProductsInput!) {
    listProducts(input: $input) {
      code
      totalElements
      totalPages
      currentPage
      pageSize
      products {
        id
        name
        description
        supplierId
        brandName
        companyId
        storeId
        category
        categoryPath
        imageUrl
        sellingMode
        baseUnit
        isPartialSellingAllowed
        status
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;

export const getProductDetailQuery = `
 query GetProductDetail($input: GetProductDetailInput!) {
       getProductDetail(input: $input) {
          code
          product {
            id
            name
            description
            supplierId
            brandName
            companyId
            storeId
            category
            categoryPath
            imageUrl
            sellingMode
            baseUnit
            isPartialSellingAllowed
            status
            createdBy
            createdAt
            updatedBy
            updatedAt
                
          }
    }
 }
`;

export const getLowStocAlertsQuery = `
 query GetLowStockAlerts {
      getLowStockAlerts {
        code
        products {
          id
          name
          description
          supplierId
          brandName
          storeId
          companyId
          category
          categoryPath
          imageUrl
          sellingMode
          baseUnit
          isPartialSellingAllowed
          status
          createdBy
          createdAt
          updatedBy
          updatedAt
              
        }
    }
 }
`;

export const createProductQuery = `
 mutation CreateProduct($input:  CreateProductInput!) {
       createProduct(input: $input) {
        code
        id
    }
 }
`;

export const updateProductQuery = `
 mutation UpdateProduct($input: UpdateProductInput!) {
      updateProduct(input: $input) {
        code
        id
    }
 }
`;

export const deleteProductQuery = `
 mutation DeleteProduct($input: DeleteProductInput!) {
      deleteProduct(input: $input) {
        code
    }
 }
`;

export const listProductItemsByProductQuery = `
  query ListProductItemsByProduct($input: ListProductItemsInput!) {
    listProductItemsByProduct(input: $input) {
      code
      totalElements
      items {
        id
        state
      }
    }
  }
`;
